import React, { Component } from "react";
import Accounts from "../../Components/Pages/Account";
import { showError, showSuccess } from "../../utils/Toast";

export class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const {
      getallorderRequest,
      getwishlistRequest,
      getaddressRequest,
      getprofileRequest,
    } = this.props;
    getallorderRequest();
    getwishlistRequest();
    getaddressRequest();
    getprofileRequest();
  }

  componentDidUpdate(prevProps) {
    const {
      addcartdata,
      getCartRequest,
      removewishlistdata,
      getwishlistRequest,
      insertprofiledata,
      insertprofileerror,
      getprofileRequest,
    } = this.props;
    if (prevProps.addcartdata !== this.props.addcartdata) {
      if (addcartdata && addcartdata.success) {
        getCartRequest();
        showSuccess("Cart Added Successfully");
      }
    }
    if (prevProps.removewishlistdata !== this.props.removewishlistdata) {
      if (removewishlistdata && removewishlistdata.success) {
        getwishlistRequest();
        showSuccess("Wish List Removed Successfully");
      }
    }
    if (prevProps.insertprofiledata !== this.props.insertprofiledata) {
      if (insertprofiledata) {
        getprofileRequest();
        showSuccess(insertprofiledata);
      }
    }
    if (prevProps.insertprofileerror !== insertprofileerror && insertprofileerror) {
      showError(insertprofileerror);
    }
  }
  render() {
    const {
      allorderdata,
      getallorderloading,
      getallordererror,
      wishlistdata,
      insertCartRequest,
      removewishlistrequest,
      getwishlistRequest,
      getallorderRequest,
      addAddressRequest,
      addAddressLoading,
      addAddressData,
      addAddressError,
      getaddressData,
      getaddressLoading,
      getaddressError,
      getaddressRequest,
      insertprofileRequest,
      insertprofileloading,
      insertprofiledata,
      insertprofileerror,
      getprofiledataData,
    } = this.props;
    return (
      <>
        <Accounts
          allorderdata={allorderdata}
          getallorderloading={getallorderloading}
          getallordererror={getallordererror}
          wishlistData={wishlistdata}
          insertCartRequest={insertCartRequest}
          removewishlistrequest={removewishlistrequest}
          getwishlistRequest={getwishlistRequest}
          getallorderRequest={getallorderRequest}
          addAddressRequest={addAddressRequest}
          addAddressLoading={addAddressLoading}
          addAddressData={addAddressData}
          addAddressError={addAddressError}
          getaddressData={getaddressData}
          getaddressLoading={getaddressLoading}
          getaddressError={getaddressError}
          getaddressRequest={getaddressRequest}
          insertprofileRequest={insertprofileRequest}
          insertprofileloading={insertprofileloading}
          insertprofiledata={insertprofiledata}
          insertprofileerror={insertprofileerror}
          getprofiledataData={getprofiledataData}
        />
      </>
    );
  }
}

export default Account;
